const initialState = {
  isLoading: false,
}

export default function dashboardAusbilder(state = initialState) {
  return state
}
